export const getNewUploadNotificationMessage = (domainLabel: string) =>
  `Your ${domainLabel} were successfully imported.`;
